export const DropDowns = {
  timezones: [
    { label: 'Pacific', value: 'America/Los_Angeles' },
    { label: 'Mountain', value: 'America/Denver' },
    { label: 'Central', value: 'America/Chicago' },
    { label: 'Eastern', value: 'America/New_York' },
    { label: 'Alaska', value: 'America/Anchorage' },
    { label: 'Hawaii', value: 'Pacific/Honolulu' },
  ],
  leadStatuses: [
    { label: 'Qualified', value: 'Qualified' },
    { label: 'Unqualified', value: 'Unqualified' },
    { label: 'Bad Lead / Tech Support', value: 'Bad Lead / Tech Support' },
    { label: 'New Lead', value: 'New lead' },
  ],
  conciergeRatingSources: [
    { label: 'Verse Ratings', value: '1' },
    { label: 'BPO Ratings', value: '2' },
    { label: 'Client Ratings', value: '3' },
    { label: 'Other', value: '4' },
  ],
};

// hotkeys for all actions within control center
export const KeyMap = {
  DONE: 'ctrl+shift+7',
  CALL: 'ctrl+shift+8',
  CONTINUE_AUTO: 'ctrl+shift+9',
};

export const SystemPresenceTimeout = 30000;

export const LogoutWarningMilliseconds = 65000;

export const SmsCharacterLimit = 1600;

export const InactiveReasons = [
  {
    value: 'break',
    text: 'Break',
  },
  {
    value: 'escalation_assistance',
    text: 'Escalation / Assistance',
  },
  {
    value: 'technical_issue_reporting',
    text: 'Technical Issue / Reporting',
  },
  {
    value: 'personal',
    text: 'Personal',
  },
  {
    value: 'meeting',
    text: 'Meeting',
  },
  {
    value: 'training_development',
    text: 'Training / Development',
  },
  {
    value: 'administrative_project_work',
    text: 'Administrative / Project Work',
  },
  {
    value: 'coaching',
    text: 'Coaching',
  },
  {
    value: 'prep_time_review_ratings',
    text: 'Prep Time / Review Ratings',
  },
  {
    value: 'lunch',
    text: 'Lunch',
  },
];
